// @ts-ignore
import RangeSlider from 'react-range-slider-input'
import 'react-range-slider-input/dist/style.css'

import styles from './styles.module.scss'

interface Props {
  min?: number
  max?: number
  value?: number[]
  disabled?: boolean
  step?: number
  onChange?: (data: number[]) => void
}

export const RangeInput = ({
  value,
  min = 0,
  max = 0,
  disabled,
  step,
  onChange,
}: Props) => {
  const _value = value ? (value as [number, number]) : undefined
  return (
    <RangeSlider
      min={min}
      max={max}
      value={_value}
      step={step}
      onInput={onChange}
      className={styles.range}
      disabled={disabled}
    />
  )
}
